<template>
  <div class="mcp-login">
    <h3>Connexion</h3>

    <div class="form-group">
      <label>Courriel</label>
      <input
        type="text"
        placeholder="Votre courriel"
        v-model="username"
        v-validate="'required'"
        name="username"
        class="form-control"
      />
    </div>

    <div class="form-group">
      <label>Mot de passe</label>
      <input
        type="password"
        placeholder="Votre mot de passe"
        v-model="password"
        v-validate="'required'"
        name="password"
        class="form-control"
      />
    </div>

    <div class="modal fade" :class="lostpop" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Réinitialisation du mot de passe</h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Envoyer un lien pour réinitialiser le mot de passe à l'adresse suivante :</label>
              <input
                type="text"
                placeholder="Votre courriel"
                v-model="lostlog"
                v-validate="'required'"
                name="lostlog"
                class="form-control"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button @click="lostpop = null" type="button" class="btn btn-secondary">Annuler</button>
            <button @click="lostPass()" type="button" class="btn btn-primary">Envoyer</button>
          </div>
        </div>
      </div>
    </div>

    <button @click="Login()" class="btn viewBtn">Se connecter</button>
    <button @click="lostpop = 'show'" class="btn btn-link mcp-lostpass">Mot de passe perdu ?</button>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      connected: false,
      username: "",
      password: "",
      lostpop: null,
      lostlog: ''
    };
  },
  methods: {
    Login: function() {
      var data = { login: this.username, password: this.password };

      this.$http
        .post(this.$url_name + "/accounts/login/", data, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          console.log("loggedin");

          localStorage.setItem("token", response.body.token);

          if (localStorage.getItem("soumissionUID")) {
            var dheader = {
              "Content-Type": "application/json",
              Authorization: "Token " + response.body.token
            };

            var data = {
              note: 'Nouveau plan',
            };

            this.$http
              .put(
                this.$url_name +
                  "/submission/" +
                  localStorage.getItem("soumissionUID") +
                  "/",
                  data,
                {
                  headers: dheader
                }
              )
              .then(response => {
                this.$toasted.show("Plan enregistré avec succès.", {
                  duration: 4000,
                  type: "success"
                });
              })
              .catch(err => {
                console.log(err);
              });
          }

          localStorage.setItem("soumissionUID", "");
          this.$logedin = true;
          this.$router.push("/soumissions/");
        })
        .catch(err => {
          localStorage.setItem("token", "");
          if ((err.status = "400")) {
            this.$toasted.show(
              "Oups! Il y a un problème avec vos informations de connexion.",
              {
                duration: 4000,
                type: "error"
              }
            );
          }
        });
    },
    lostPass: function() {
      var data = { login: this.lostlog };
      this.$http.post(this.$url_name + "/accounts/send-reset-password-link/", data, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        this.lostpop = null
      }).catch(err => {
        if ((err.status = "400")) {
          this.$toasted.show(
            "Oups! Il y a un problème avec vos informations de connexion.",
            {
              duration: 4000,
              type: "error"
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
.mcp-login {
  width: 40%;
  padding: 10vh 10% 10vh 0;
  margin: 0 auto;
}
.mcp-lostpass{
  font-size:.8rem;
  line-height:120%;
  padding:5px
}
.mcp-login .modal-dialog{
  max-width: 600px;
  padding:10px;
}
.show{
  display:inline-block;
  top:20vh
}
@media (max-width: 1999px) {
    .mcp-login{width:50%;padding:10vh 0}
}
@media (max-width: 1023px) {
    .mcp-login{width:75%;padding:10vh 0}
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue